import loadable from '@loadable/component';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isNewbuildingPageSelector } from 'shared/selectors';
import { isRentDailySelector } from 'shared/selectors/isRentDaily';
import { selectIsBookedFromDeveloper } from 'shared/selectors/newbuildingBookedFromDeveloper';
import { isCommercialSelector } from 'shared/selectors/offerData/offer/isCommercialSelector';
import { isSuburbanSelector } from 'shared/selectors/suburban/isSuburbanSelector';
import { getChats } from 'shared/services/chats/getChats';

const NewbuildingPageContainerLoadable = loadable(
  () => import('shared/containers/NewbuildingPageContainer/NewbuildingPageContainer'),
);
const NewbuildingBookedPageContainerLoadable = loadable(
  () => import('shared/containers/NewbuildingBookedPageContainer/NewbuildingBookedPageContainer'),
);
const CommercialPageContainerLoadable = loadable(
  () => import('shared/containers/CommercialPageContainer/CommercialPageContainer'),
);
const SuburbanPageContainerLoadable = loadable(
  () => import('shared/containers/SuburbanPageContainer/SuburbanPageContainer'),
);
const DailyRentPageContainerLoadable = loadable(
  () => import('shared/containers/DailyRentPageContainer/DailyRentPageContainer'),
);
const FlatPageContainerLoadable = loadable(() => import('shared/containers/FlatPageContainer/FlatPageContainer'));

export const PageContainer = () => {
  const isNewbuilding = useSelector(isNewbuildingPageSelector);
  const isCommercial = useSelector(isCommercialSelector);
  const isRentDaily = useSelector(isRentDailySelector);
  const isSuburban = useSelector(isSuburbanSelector);
  const isBookedFromDeveloper = useSelector(selectIsBookedFromDeveloper);

  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(getChats());
  }, []);

  if (isCommercial) {
    return <CommercialPageContainerLoadable />;
  }

  if (isNewbuilding && isBookedFromDeveloper) {
    return <NewbuildingBookedPageContainerLoadable />;
  }

  if (isNewbuilding) {
    return <NewbuildingPageContainerLoadable />;
  }

  if (isRentDaily) {
    return <DailyRentPageContainerLoadable />;
  }

  if (isSuburban) {
    return <SuburbanPageContainerLoadable />;
  }

  return <FlatPageContainerLoadable />;
};
